module.exports = __webpack_public_path__ + "img/fonticons-fi.719e2742.svg";